import { css, cx } from 'emotion';

import {
	darkGrey,
	headingXLarge,
	headingMedium,
	sideBarLayout,
	cardSection,
	mobileMaxWidthBreakpoint,
	tabletPortraitMinWidthBreakpoint,
	desktopMaxWidthBreakpoint,
} from 'inside-out/global-styles';

export const headerWrapperStyle = css({
	maxWidth: desktopMaxWidthBreakpoint,
	width: '100%',
	height: '100%',
	margin: '0 auto',
	paddingTop: '45px',
	'& > h1, & > div': {
		padding: '0 20px',
	},
	[`@media (max-width: ${mobileMaxWidthBreakpoint}px)`]: {
		paddingTop: '30px',
		'& h1': {
			marginBottom: '30px',
		},
	},
});

export const tabPageWrapper = css({
	backgroundColor: '#F6F6F6',
	paddingTop: '36px',
	[`@media (max-width: ${mobileMaxWidthBreakpoint}px)`]: {
		paddingTop: 0,
		//backgroundColor: '#fff',
	},
});

export const titleStyle = cx(
	headingXLarge,
	css({
		marginBottom: '45px',
	})
);

export const subTitleStyle = cx(
	headingMedium,
	css({
		[`@media (max-width: ${mobileMaxWidthBreakpoint}px)`]: {
			fontSize: '16px',
			lineHeight: '18px',
		},
	})
);

export const navContainerStyle = css({
	position: 'sticky',
	top: '102px',
	zIndex: 3,
	background: '#fff',
})

export const navStyle = css({
	maxWidth: desktopMaxWidthBreakpoint,
	width: '100%',
	margin: '0 auto',
});

export const formStyle = css({
	marginBottom: '45px',
	display: 'flex',
	justifyContent: 'flex-start',

	[`@media (max-width: ${tabletPortraitMinWidthBreakpoint}px)`]: {
		marginBottom: '30px',
		flexDirection: 'column',
		alignItems: 'stretch',
		'& input': {
			width: 'calc(100% - 46px)',
		},
	},
});

export const dropdownStyle = css({
	width: 255,
	flex: '0 0 auto',
	marginRight: 16,
	[`@media (max-width: ${tabletPortraitMinWidthBreakpoint}px)`]: {
		width: '100%',
		flexGrow: 1,
		marginRight: 0,
		marginBottom: 16,
	}
});

export const spacerStyle = css({
	height: 43,
});

export const pageControlsStyle = css({
	display: 'table',
	width: '100%',
	'& p': {
		display: 'table-cell',
		width: '100%',
		color: darkGrey,
		fontSize: '16px',
		lineHeight: '19px',
	},
	'& > div': {
		display: 'table-cell',
	},
	[`@media (max-width: ${mobileMaxWidthBreakpoint}px)`]: {
		'& p, & > div': {
			display: 'block',
		},
	},
});

export const sectionStyle = cardSection(60);

export const innerWrapperStyle = sideBarLayout.wrapper;

export const mobileFiltersStyle = sideBarLayout.mobileFilters;

export const mobileFiltersDropDownStyle = sideBarLayout.mobileFiltersDropDown;



// WEBPACK FOOTER //
// ./src/page-styles/resource-library/index.js